
import Node from 'ln/node/Node';
import Template from 'ln/template/TemplateManager';
import View from 'ln/view/View';
import ListRenderer from 'ln/list/ListRenderer';
import CourseListFilterView from './views/CourseListFilterView';
import SharedCourseListFilterView from './views/SharedCourseListFilterView';
import MediaSearchView from "./views/MediaSearchView";
import Daybreak from '../course/models/DaybreakModel';
import UserCourseModel from '../course/models/UserCourseModel';
import setup from 'ln/setup/setup';
import { scanner } from 'ln/view/Scanner';


class Library extends View {

	init() {
		this.showCourses();
		this.showUserCourses();
		this.showSharedCourses();
		this.renderBooks();
		this.showMedia();
		scanner.scan( this.node );
	}

	showCourses() {

		var comparisonAttributes = {
			tagFilterAttributes: [ 'form', 'level' ],
			searchFilterAttributes: [ 'title', 'description' ]
		};

		var standardCourseListFilter = new CourseListFilterView( setup.data( 'standardCourses' ), comparisonAttributes );
		standardCourseListFilter.render( this.node.js( 'standard-courses' ) );

	}

	showUserCourses() {

		var userCourseModels = setup.data( 'myCourses' ) as UserCourseModel[];

		// sort the user courses
		this.sortDesc( userCourseModels );

		var comparisonAttributes = {
			tagFilterAttributes: [ 'type', 'level', 'status', 'certificationType', 'form' ],
			searchFilterAttributes: [ 'title', 'description' ]
		};

		let myCoursesFilter = new CourseListFilterView( userCourseModels, comparisonAttributes );
		myCoursesFilter.render( this.node.js( 'my-courses' ) );
		
	}

	showSharedCourses() {

		if( this.node.js( 'shared-courses' ) ){
			var sharedCourses = setup.data( 'sharedCourses' ) as UserCourseModel[];
			
			// sort the user courses
			this.sortDesc( sharedCourses );

			var comparisonAttributes = {
				tagFilterAttributes: [ 'type', 'level', 'status', 'certificationType', 'form' ],
				searchFilterAttributes: [ 'title', 'description' ]
			};
			
			let mySharedCoursesFilter = new SharedCourseListFilterView( sharedCourses, comparisonAttributes );
			mySharedCoursesFilter.render( this.node.js( 'shared-courses' ) );
		}
	
	}
	
	renderBooks() {

		if( this.node.js( 'books' ) ){
			var bookListRenderer = new ListRenderer( this.node.js( 'books' ) );
	
			bookListRenderer.defaultRender( ( item:any ) => {
				var node = Node.fromHTML( Template.render( 'krw.booklistbook', item )); 
				return { node: node };
			});
	
			bookListRenderer.source.fill( setup.data( 'books' ) );
		}
		
	};

	showMedia() {
		let mediaSearch = new MediaSearchView( setup.data( 'standardCourses' ) );
		mediaSearch.render( this.node.js( 'medias' ) );
	}

	/**
	 * Sort usercourses by daybreak desc
	 */
	private sortDesc( userCourseModels:UserCourseModel[]){
		userCourseModels.sort( ( a, b ) => {
			var daybreak1 = a.sequences.get( 0 ) as Daybreak;
			var daybreak2 = b.sequences.get( 0 ) as Daybreak;
			return ( daybreak1.date >= daybreak2.date ) ? -1 : 1;
		});
	}
	
}

export default Library;


scanner.ioc.add( 'library', function( node ) {
	return new Library().render( node );
});